import api from '../../plugins/api';

const getDocumentHistory = (id) => {
  return api.get('/api/documents/getDocumentHistory', { id });
};

export default getDocumentHistory;
